interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export interface ConfirmAuthOTPState {
    confirmAuthOTPData: any|number;
    confirmAuthOTPLoading: boolean;
    confirmAuthOTPError: ErrorResponse | null;
}


export enum ConfirmAuthOTPActionTypes {
    FETCH_CONFIRM_AUTH_OTP_DATA = "FETCH_CONFIRM_AUTH_OTP_DATA",
    FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS = "FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS",
    FETCH_CONFIRM_AUTH_OTP_DATA_ERROR = "FETCH_CONFIRM_AUTH_OTP_DATA_ERROR",
}

export type ConfirmAuthOTPCreateAction =
    | { type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA }
    | { type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS; payload: any[]|number }
    | { type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_ERROR; payload: any };